export const buildQueryFromOptionalParams = (
  params: OptionalParamsObject
): string =>
  Object.entries(params)
    .map(([key, value]) => (value !== undefined ? `&${key}=${value}` : ""))
    .join("");
